import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import SessionManager from './utils/sessionManager'
import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import { iconsSet as icons } from '@/assets/icons'
import DocsCallout from '@/components/DocsCallout'
import DocsExample from '@/components/DocsExample'
import Toaster from "@meforma/vue-toaster";


const app = createApp(App)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.use(Toaster)

app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('DocsCallout', DocsCallout)
app.component('DocsExample', DocsExample)

const sessionManager = new SessionManager()
sessionManager.init(app)

app.mount('#app')
